// Project names display in Title Case whatever was typed (stored value is untouched).
// Keep in step with api-integrations/project-creator/client/src/lib/titleCase.js.
(function () {
  var MINOR = ['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'in', 'nor', 'of', 'on', 'or', 'the', 'to'];
  // Product-line abbreviations that stay upper case (PC = Postage Collage).
  var KEEP_UPPER = ['PC'];
  var LETTER = 'a-zà-ÿ';
  var startRe = new RegExp('^([^' + LETTER + '0-9]*)([' + LETTER + '])');
  var innerRe = new RegExp('([-/(])([' + LETTER + '])', 'g');

  function titleCase(text) {
    if (!text) return text;
    var words = String(text).trim().split(/\s+/);
    return words.map(function (word, index) {
      var lower = word.toLowerCase();
      if (KEEP_UPPER.indexOf(word.replace(/^[^a-z0-9]+|[^a-z0-9]+$/gi, '').toUpperCase()) !== -1) {
        return word.replace(/[a-z]+/gi, function (m) { return KEEP_UPPER.indexOf(m.toUpperCase()) !== -1 ? m.toUpperCase() : m; });
      }
      if (index > 0 && index < words.length - 1 && MINOR.indexOf(lower) !== -1) return lower;
      return lower
        .replace(startRe, function (m, lead, c) { return lead + c.toUpperCase(); })
        .replace(innerRe, function (m, sep, c) { return sep + c.toUpperCase(); });
    }).join(' ');
  }

  window.wfTitleCase = titleCase;

  function apply() {
    document.querySelectorAll('[data-title-case]').forEach(function (el) {
      el.textContent = titleCase(el.textContent);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
